import classNames from '@/helpers/classNames';
import { useEffect, useRef } from 'react';

export type NotificationOptions = {
  text: string;
  position?: 'top' | 'bottom' | 'left' | 'right';
  title?: string;
  type?: 'default' | 'success' | 'error' | 'warning' | 'info';
  hideTimeout?: number;
};

function Notification({ position, title, text, type }: NotificationOptions) {
  // use tailwindcss to style the notification, should animate in and out
  const notificationClasses = classNames(
    'fixed',
    'p-4',
    'rounded-md',
    'text-white',
    'font-medium',
    'shadow-lg',
    'z-50',
    'transition',
    'duration-500',
    'ease-in-out',
    'transform',
    'opacity-0',
    'scale-90',
    type === 'default' ? 'bg-gray-500' : '',
    type === 'success' ? 'bg-green-500' : '',
    type === 'error' ? 'bg-red-500' : '',
    type === 'warning' ? 'bg-yellow-500' : '',
    type === 'info' ? 'bg-blue-500' : '',
    position === 'top' ? 'top-8' : '',
    position === 'bottom' ? 'bottom-8' : '',
    position === 'left' ? 'left-8 top-8' : '',
    position === 'right' ? 'right-8 top-8' : ''
  );
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (ref.current) {
      setTimeout(() => {
        ref.current?.classList.add('opacity-100');
      }, 100);
    }
  }, [ref]);

  return (
    <div
      ref={ref}
      className={notificationClasses}
      data-testid="notification"
      style={{ zIndex: 555 }}>
      {title && <h3 className="text-lg">{title}</h3>}
      <p>{text}</p>
    </div>
  );
}

Notification.defaultProps = {
  position: 'right',
  type: 'info',
  hideTimeout: 5000,
  title: null
};

export default Notification;
